"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileFilterSideBar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const MobileFilter_1 = require("Views/Shared/Components/MobileFilter/MobileFilter");
const SideBar_1 = require("Views/Shared/Components/SideBar/SideBar");
const context_1 = require("../context");
const SearchResultFilterService_1 = require("../services/SearchResultFilterService");
const MobileFilterSideBar = () => {
    const { filters, hierarchyFilters, isMobileFiltersOpen, clearAllRefinements, setIsMobileFiltersOpen, setLastUserAction, updateSnapshot, resetToPreviousSnapshot, selectedFilterOptionsCount, dictionary, } = (0, context_1.useSearchResultContext)();
    const keyMappedFilters = React.useMemo(() => SearchResultFilterService_1.searchResultFilterService.getKeyMappedFilters(filters, hierarchyFilters), [filters, hierarchyFilters]);
    const filterHandler = React.useCallback((key, value, isUnselect = false) => {
        var _a;
        const isReset = value === '';
        const selectedFilter = keyMappedFilters[key];
        selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.refine(value);
        const gtmKey = (selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.gtmKey) || key;
        const type = (_a = selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.type) !== null && _a !== void 0 ? _a : app_1.FilterTypeEnum.SingleSelect;
        setLastUserAction({
            name: isUnselect || isReset ? app_1.LastUserActionNameEnum.Unfilter : app_1.LastUserActionNameEnum.Filter,
            key: gtmKey,
            value,
            type,
        });
    }, [keyMappedFilters]);
    const resetFilterHandler = React.useCallback((key) => {
        const selectedFilter = keyMappedFilters[key];
        selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.clearRefinements();
    }, [keyMappedFilters]);
    const orderedFilters = React.useMemo(() => SearchResultFilterService_1.searchResultFilterService.orderFilterWithStatusAtEnd(filters, hierarchyFilters), [filters, hierarchyFilters]);
    return ((0, jsx_runtime_1.jsx)(SideBar_1.Sidebar, { isOpened: isMobileFiltersOpen, children: (0, jsx_runtime_1.jsx)(MobileFilter_1.default, { filters: orderedFilters, filterHandler: filterHandler, resetFilterHandler: resetFilterHandler, onClose: () => setIsMobileFiltersOpen(false), resetAllFilters: clearAllRefinements, updateSnapshot: updateSnapshot, resetToPreviousSnapshot: resetToPreviousSnapshot, selectedFilterOptionsCount: selectedFilterOptionsCount, dictionary: dictionary }) }));
};
exports.MobileFilterSideBar = MobileFilterSideBar;
